import { useState } from "react";
import {
  Box, Grid, TextField, Button, Typography,
  IconButton, MenuItem, Autocomplete
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { stockService } from "../service/CreateStockService";

export const MODEL_SKU_LIST = [
  { model: "CT 110 X",                      sku: "DY13" },
  { model: "PLA 100 ES NXT",                sku: "JK39" },
  { model: "PLA 110 DRUM ES NXT",           sku: "JK38" },
  { model: "PUL 125 CF DISC L/S UG",        sku: "DH62" },
  { model: "PUL 125 CF DISC S/S UG",        sku: "DH58" },
  { model: "PUL 125 NEON DISC L/S",         sku: "DH65" },
  { model: "PUL 125 CF DISC L/S LED",       sku: "DH71" },
  { model: "PUL 125 CF DISC S/S LED",       sku: "DH70" },
  { model: "PUL 125 NEON DISC LED",         sku: "DH73" },
  { model: "PUL NS 125 UG ABS OBD2B",       sku: "JF60" },
  { model: "PUL NS 125 UG ABS",          sku: "JF61" },
  { model: "PUL N125 TOP",                  sku: "JZ51" },
  { model: "PUL 150 TD UG",                 sku: "DH61" },
  { model: "PUL 150 TD UG LED",             sku: "DH69" },
  { model: "PUL 150 TD UG HL",              sku: "DH63" },
  { model: "PUL NS 160 UG",                 sku: "JF45" },
  { model: "PUL NS 200 UG",                  sku: "JL25" },
  { model: "PUL 220F UG",                  sku: "DK13" },
  { model: "PUL 220F WITH LED BLINKER",     sku: "DK14" },
  { model: "PUL RS 200 UG",                 sku: "DT22" },
  { model: "PUL N 250 UG",                   sku: "JR34" },
  { model: "Freedom 125",                   sku: "JH27" },
  { model: "PUL N 160 UG",                  sku: "JR33" },
  { model: "PUL N 160 TD TC with USD Fork",  sku: "JR63" },
  { model: "PUL 180 L/S LED",               sku: "DJ16" },
  { model: "PUL NS 400Z UG",                sku: "JL28" },
  { model: "AVG 220 STREET",                sku: "PD40" },
  { model: "DOMI D250 UG",                  sku: "JF53" },
  { model: "DOMI D400 UG",                  sku: "JF52" },
  { model: "DOMI D400 UG",                  sku: "JF62" },
  { model: "PUL N 160 LSTD",                  sku: "JR50" },
  { model: "PUL NS 125 DIGITAL",                  sku: "JF44" },
  { model: "PUL 150 SD",                  sku: "DH68" },
  { model: "PUL NS 160 TC ABS",                  sku: "JF55" },
  { model: "PUL NS 125 WIDER TYER",                  sku: "JF51" },
  { model: "CHETAK 3503",                  sku: "GL56" },
  { model: "PUL N 160 L/S TD",                  sku: "JR82" },
  { model: "PUL N 160 S/S TD",                  sku: "JR83" },
  { model: "PUL NS 400Z",                  sku: "JL32" },
  { model: "PUL 220 UG",                  sku: "DK15" },
  { model: "AVG 220 CRUISE",                  sku: "PD38" },
  { model: "CHETAK 2501",                  sku: "GL21" },
  {model: "PUL N 160 SS 4V TD TC",                  sku: "JR54" },
  {model: "PUL N 160 S 4V TD SC",                  sku: "JR75" },
  {model: "PUL 125 STANDARD L/S LCD",                  sku: "JR70" },
    {model: "PUL NS 400 TFT",                  sku: "JL34" },
     {model: "PLATINA 110",                  sku: "JK35" },
              {model: "PUL NS 125 LCD CBS",                  sku: "JF67" },
{model: "PULSAR NS 125 LCD ABS",                  sku: "JF65" },
{model: "PUL NS 200 TFT",                  sku: "JL31" },
   {
    model: "PUL 150 TD STANDARD L/S LCD",
    sku: "JR67"
  },
  {
    model: "PUL 150 TD STANDARD L/S TFT",
    sku: "JR68"
  },
  {
    model: "PUL 150 TD PREMIUM S/S TFT",
    sku: "JR90"
  },
  {
    model: "PUL 150 TD STANDARD S/S TFT",
    sku: "JR91"
  },
  {
    model: "PUL 125 STANDARD L/S TFT",
    sku: "JR72"
  },
  {
    model: "PUL 125 STANDARD S/S TFT",
    sku: "JR71"
  },
  {
    model: "PUL 125 PREMIUM S/S TFT",
    sku: "JR73"
  },
  {
    model: "PUL N 160 2V TD SC",
    sku: "JR81"
  }

  
 ];
 
const CreateStockForm = ({ onSuccess, onClose }) => {

  const [form, setForm] = useState({
    challanNo: "",
    model: "",
    skuCode: "",
    colour: "",
    chasis: "",
    engine: "",
    keyNumber: "",
    exShowroomPrice: "",
    purchasePrice: "",
    remarks: "",
    location: "",
    date: new Date().toISOString().split("T")[0],
  });

  const [errors, setErrors] = useState({});

  // ── VALIDATION ────────────────────────────────────────────────────────────
  const validate = (fieldValues = form) => {
    let temp = {};
    Object.keys(fieldValues).forEach((key) => {
      if (key !== "remarks" && !fieldValues[key]) {
        temp[key] = "This field is required";
      }
    });
    if (fieldValues.purchasePrice && isNaN(fieldValues.purchasePrice))
      temp.purchasePrice = "Must be a number";
    if (fieldValues.exShowroomPrice && isNaN(fieldValues.exShowroomPrice))
      temp.exShowroomPrice = "Must be a number";
    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  // ── HANDLE CHANGE ─────────────────────────────────────────────────────────
  const handleChange = (e) => {
    let value = e.target.value;
    if (["engine", "chasis"].includes(e.target.name)) value = value.toUpperCase();
    const updatedForm = { ...form, [e.target.name]: value };
    setForm(updatedForm);
    validate(updatedForm);
  };

  // ── MODEL select → auto-fill SKU ──────────────────────────────────────────
  const handleModelChange = (_, selected) => {
    const updatedForm = {
      ...form,
      model:   selected?.model || "",
      skuCode: selected?.sku   || "",
    };
    setForm(updatedForm);
    validate(updatedForm);
  };

  // ── SKU select → auto-fill Model ──────────────────────────────────────────
  const handleSkuChange = (_, selected) => {
    const updatedForm = {
      ...form,
      model:   selected?.model || "",
      skuCode: selected?.sku   || "",
    };
    setForm(updatedForm);
    validate(updatedForm);
  };

  // ── SUBMIT ────────────────────────────────────────────────────────────────
 const handleSubmit = async () => {
  if (!validate()) return;

  const result = await stockService.createStock(form);

  if (!result.success) {
    window.alert(result.message);
    return;
  }

  onSuccess();
  onClose();
};
  const isFormValid = Object.keys(form)
    .filter((key) => key !== "remarks")
    .every((key) => form[key] !== "");

  // ── SELECTED OPTION OBJECTS ───────────────────────────────────────────────
  const selectedModelOption =
    MODEL_SKU_LIST.find(
      (o) => o.model === form.model && o.sku === form.skuCode
    ) || null;

  const selectedSkuOption =
    MODEL_SKU_LIST.find(
      (o) => o.sku === form.skuCode && o.model === form.model
    ) || null;

  // ── RENDER EACH FIELD ─────────────────────────────────────────────────────
  const renderField = (key) => {

    // 🔽 MODEL — searchable autocomplete
    if (key === "model") {
      return (
        <Autocomplete
          options={MODEL_SKU_LIST}
          getOptionLabel={(o) => o.model}
          isOptionEqualToValue={(option, value) =>
            option.model === value.model && option.sku === value.sku
          }
          value={selectedModelOption}
          onChange={handleModelChange}
          renderOption={(props, option) => (
            <li {...props} key={option.model + option.sku}>
              <Box>
                <Typography variant="body2" fontWeight={600}>{option.model}</Typography>
                <Typography variant="caption" color="text.secondary">SKU: {option.sku}</Typography>
              </Box>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="Model"
              error={!!errors.model}
              helperText={errors.model}
            />
          )}
        />
      );
    }

    // 🔽 SKU — searchable autocomplete, full 4-digit code always visible
    if (key === "skuCode") {
      return (
        <Autocomplete
          options={MODEL_SKU_LIST}
          getOptionLabel={(o) => o.sku}
          isOptionEqualToValue={(option, value) =>
            option.sku === value.sku && option.model === value.model
          }
          value={selectedSkuOption}
          onChange={handleSkuChange}
          renderOption={(props, option) => (
            <li {...props} key={option.model + option.sku}>
              <Box>
                <Typography variant="body2" fontWeight={600}>{option.sku}</Typography>
                <Typography variant="caption" color="text.secondary">{option.model}</Typography>
              </Box>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label="SKU Code"
              error={!!errors.skuCode}
              helperText={errors.skuCode}
              // ✅ Force the input to always show full SKU value
              inputProps={{
                ...params.inputProps,
                value: form.skuCode || params.inputProps.value,
                style: {
                  ...params.inputProps?.style,
                  minWidth: "60px",   // ✅ ensures 4-char codes never get clipped
                  letterSpacing: "0.08em",
                  fontWeight: 600,
                },
              }}
            />
          )}
        />
      );
    }

    // 🔽 LOCATION — dropdown
    if (key === "location") {
      return (
        <TextField
          select fullWidth label="Location" name="location"
          value={form.location} onChange={handleChange}
          error={!!errors.location} helperText={errors.location}
        >
          <MenuItem value="Khejuri">Khejuri</MenuItem>
          <MenuItem value="Chaitanyapur">Chaitanyapur</MenuItem>
          <MenuItem value="Nandigram">Nandigram</MenuItem>
        </TextField>
      );
    }

    // 🔡 DEFAULT — text field
    return (
      <TextField
        fullWidth
        label={key.charAt(0).toUpperCase() + key.slice(1)}
        name={key}
        type={key === "date" ? "date" : "text"}
        value={form[key]}
        onChange={handleChange}
        error={!!errors[key]}
        helperText={errors[key]}
        InputLabelProps={key === "date" ? { shrink: true } : {}}
        inputProps={
          key === "date"
            ? { max: new Date().toISOString().split("T")[0] }
            : {}
        }
      />
    );
  };

  return (
    <Box p={3} position="relative">

      {/* ❌ CLOSE */}
      <IconButton onClick={onClose} sx={{ position: "absolute", top: 10, right: 10 }}>
        <CloseIcon />
      </IconButton>

      <Typography variant="h6" gutterBottom>Create Stock</Typography>

      {/* ── SELECTED MODEL + SKU DISPLAY (shown only after selection) ── */}
      {form.model && form.skuCode && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 2,
            p: 1.5,
            borderRadius: 2,
            background: "#f0f4ff",
            border: "1px solid #c7d4f5",
          }}
        >
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              SELECTED MODEL
            </Typography>
            <Typography variant="body2" fontWeight={700} color="primary">
              {form.model}
            </Typography>
          </Box>
          <Box sx={{ width: "1px", height: 32, background: "#c7d4f5" }} />
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              SKU CODE
            </Typography>
            {/* ✅ SKU displayed in a pill/badge — always full 4 chars */}
              <Typography variant="body2" fontWeight={700} color="primary">
              {form.skuCode}
            </Typography>
            </Box>
        </Box>
      )}

      {/* FORM */}
      <Grid container spacing={2} mt={1}>
        {Object.keys(form).map((key) => (
          <Grid item xs={12} md={6} key={key}>
            {renderField(key)}
          </Grid>
        ))}
      </Grid>

      {/* SUBMIT */}
      <Button
        fullWidth sx={{ mt: 3 }} variant="contained"
        onClick={handleSubmit}
        disabled={!isFormValid || Object.keys(errors).length > 0}
      >
        Create
      </Button>
    </Box>
  );
};

export default CreateStockForm;